<template>
    <!-- Start Awesome Section -->
    <section class="awesome text-center">
        <h1>Why This Is Awesome</h1>
        <p>Lorem ipsum dolor sit amet, consectetur adipisicing elit.</p>
        <!-- Start Container -->
        <div class="container">
            <!-- Start Row -->
            <div class="row">
                <!-- Start Column -->
                <div
                    class="col-md-4"
                    v-for="feature_icon_class in features_icons_classes"
                    :key="feature_icon_class.id"
                >
                    <!-- Start Feature Box -->
                    <div class="feat-box">
                        <i :class="[feature_icon_class.className, 'fa-2x']"></i>
                        <h4>Thoughtful Design</h4>
                        <p>Lorem ipsum dolor sit amet, consectetur adipisicing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua.</p>
                    </div>
                    <!-- End Feature Box -->
                </div>
                <!-- End Column -->
            </div>
            <!-- End Row -->
        </div>
        <!-- End Container -->
    </section>
    <!-- End Awesome Section -->
</template>

<style scoped lang="scss">

    .awesome{
        padding: var(--main-padding);
        background-color: var(--second-background);

        h1{
            position: relative;
            margin-bottom: 40px;

            & + p{
                margin-bottom: 50px;
                @media(max-width: 767px){
                    margin-bottom: 30px
                }
            }

            &::after{
                content: '';
                position: absolute;
                bottom: -20px;
                left: calc(50% - 50px);
                width: 100px;
                height: 3px;
                background-color: var(--main-color);
            }

        }

        p{
            color: var(--second-color)
        }

        .feat-box{

            i{
                border: 1px solid var(--main-color);
                border-radius: 50%;
                width: 60px;
                height: 60px;
                line-height: 60px;
                color: var(--main-color);
                transition: .5s;
                &:hover{
                    background-color: var(--main-color);
                    color: #FFF;
                }
            }

            h4{
                margin: {
                    top: 20px;
                    bottom: 15px
                }
            }

            @media(max-width: 991px){
                padding-bottom: 20px
            }

        }
    }
</style>

<script>

    import {features_icons_classes} from "../../assets/jsonData/index.json"

    export default {

        name: "Awesome",

        data: function() {
            
            return {

                features_icons_classes

            }
        
        }

    }

</script>